import React from 'react';
import { About } from '../styles';
import styled from 'styled-components';
import Toggle from './Toggle';
import { AnimateSharedLayout } from 'framer-motion';
//Scroll animation
import { reveal } from '../animation';
import { useScroll } from './useScroll';

const FaqSection = () => {
  const [element, controls] = useScroll();
  return (
    <Faq
      transition={{ duration: 0.5 }}
      ref={element}
      animate={controls}
      initial="hidden"
      variants={reveal}
    >
      <h2>
        Any Questions? <span>FAQ</span>
      </h2>

      <AnimateSharedLayout>
        <Toggle title="Who Am I ?">
          <div className="answer">
            
            <p>
            My Name is Abdelsamad and i work as a chef in Marriott hotel.
            </p>
          </div>
        </Toggle>
        <Toggle title="Expertise ?">
          <div className="answer">
          
            <p>
            I've worked as a chef for over 10 years mostly at Marriott and i have a Master's in Pasta Making.
            </p>
          </div>
        </Toggle>
      </AnimateSharedLayout>
    </Faq>
  );
};
const Faq = styled(About)`
  min-height: 90vh;
  padding: 5rem 10rem 3rem 10rem;
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content: space-around;
  span {
    display: block;
    color: #23d997;
  }
  h2 {
    font-weight: lighter;
  }
  .faq-line {
    background: #cccccc;
    height: 0.2rem;
    margin: 1rem 0rem;
    width: 100%;
  }
  .answer {
    padding: 2rem 0rem;
    p {
      padding: 1rem 0rem;
    }
  }


  @media (max-width:1200px){
    padding: 4rem 3rem ;
    align-items:center;
    text-align:center;
  }
  @media (max-width:450px){
    padding: 2rem 1rem ;
    h2{
      font-size: 2.8rem;
    }
    p{
      font-size: 1.2rem;
    }
  }
`;

export default FaqSection;
